module.exports = __webpack_public_path__ + "static/media/Rubik-Black.f8b41ef6.woff2";